import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const Navbar = ({ onFileUpload }) => {
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <nav className="navbar">
      <div className="navbar__container">
        <a href="/" className="navbar__brand">
          PDF Editor Pro
        </a>
        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf"
          onChange={onFileUpload}
          style={{ display: 'none' }}
        />
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  onFileUpload: PropTypes.func.isRequired
};

export default Navbar;
